import { useLingui } from '@lingui/react/macro';
import { memo } from 'react';

import { Card } from '@/components/card/Card';
import { SchemaFields } from '@/components/form/SchemaFields';
import { useFieldsSchema } from '@/components/form/useFieldsSchema';

export const PersonalizationFields = memo(() => {
  const { t } = useLingui();
  const { schema } = useFieldsSchema(
    [
      {
        name: 'chatbotConfig.initialMessage',
        label: t`Initial message`,
        type: 'richtext',
        defaultValue: t`Hello, I'm Tina! How can I help you today?`,
        showOptional: false,
      },
      {
        name: 'chatbotConfig.showPopup',
        label: t`Show bubble popup`,
        type: 'checkbox',
        uiControl: 'switch',
        defaultValue: true,
        showOptional: false,
      },
      {
        $relevant: {
          $when: ({ formState }) =>
            (formState?.values as any)?.chatbotConfig?.showPopup,
          $fields: [
            {
              name: 'chatbotConfig.bubbleTitle',
              label: t`Bubble title`,
              type: 'text',
              defaultValue: t`Hello, I'm Tina!`,
              showOptional: false,
            },
            {
              name: 'chatbotConfig.bubbleDescription',
              label: t`Bubble description`,
              type: 'text',
              defaultValue: t`Ask me anything!`,
              showOptional: false,
            },
            {
              name: 'chatbotConfig.showPopupMobile',
              label: t`Show bubble popup on mobile`,
              type: 'checkbox',
              uiControl: 'switch',
              defaultValue: false,
              showOptional: false,
            },
          ],
        },
      },
      {
        name: 'chatbotConfig.showFeedbackButtons',
        label: t`Show buttons for collecting feedback`,
        type: 'checkbox',
        uiControl: 'switch',
        defaultValue: true,
        showOptional: false,
      },
    ],
    [t],
  );

  return (
    <Card title={t`Personalization`}>
      <SchemaFields schema={schema} />
    </Card>
  );
});
